import { Link } from 'react-router-dom'
import { Head } from 'vite-react-ssg'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { getAuthor } from '../data/authors'
import { articles, featuredArticle } from '../data/articles'

const allArticles = [featuredArticle, ...articles]

export default function Articles() {
  return (
    <div className="os-root">
      <Head>
        <title>Field Dispatches · Original Savage</title>
        <meta
          name="description"
          content="The full archive of Original Savage field dispatches: food & water storage, off-grid power, skills, gear, and first-aid basics."
        />
        <link rel="canonical" href="https://originalsavage.com/articles" />
      </Head>
      <Header />
      <main id="main">
        <section className="wrap sec">
          <div className="sec-head">
            <div>
              <div className="idx">
                FIELD DISPATCHES &middot; <b>FULL ARCHIVE</b>
              </div>
              <h1>Every Dispatch</h1>
            </div>
          </div>
          <div className="art-grid archive-grid">
            {allArticles.map((a) => {
              const author = getAuthor(a.authorSlug)
              return (
                <article className="card" key={a.slug}>
                  <div className="meta">
                    <span className="tag">{a.tag}</span>
                    <span className="stamp tnum">{a.date}</span>
                  </div>
                  <h2>
                    <Link to={`/articles/${a.slug}`}>{a.title}</Link>
                  </h2>
                  <p className="dek">{a.dek}</p>
                  <div className="foot">
                    <Link className="by" to={`/authors/${author.slug}`}>
                      {author.name}
                    </Link>
                    <Link className="read" to={`/articles/${a.slug}`}>
                      Read <span aria-hidden="true">&rarr;</span>
                    </Link>
                  </div>
                </article>
              )
            })}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}
